import { Navigate, Route, Routes } from "react-router";

import { AdminLayout } from "@/components/layout/admin-layout";
import { ClientLayout } from "@/components/layout/client-layout";
import { AdminHomePage } from "@/pages/admin/home";
import { ClientCalculatorPage } from "@/pages/client/calculator";
import { ClientIntroPage } from "@/pages/client/intro";
import { ClientInvestmentRoiPage } from "@/pages/client/investment-roi";
import { ClientReportReadyPage } from "@/pages/client/report-ready";
import { ClientReportResultsPage } from "@/pages/client/report-results";
import { ClientWorkflowPage } from "@/pages/client/workflow";
import { NotFoundPage } from "@/pages/not-found";

const clientFunnelRoutes = (
  <>
    <Route index element={<ClientIntroPage />} />
    <Route path="workflow" element={<ClientWorkflowPage />} />
    <Route path="calculator/report" element={<ClientReportReadyPage />} />
    <Route path="calculator/results" element={<ClientReportResultsPage />} />
    <Route path="calculator/investment" element={<ClientInvestmentRoiPage />} />
    <Route path="calculator/:step" element={<ClientCalculatorPage />} />
  </>
);

export default function App() {
  return (
    <Routes>
      <Route index element={<Navigate to="/client" replace />} />

      <Route path="client" element={<ClientLayout />}>
        {clientFunnelRoutes}
      </Route>

      <Route path="presenter" element={<ClientLayout />}>
        {clientFunnelRoutes}
      </Route>

      <Route path="admin/login" element={<Navigate to="/admin" replace />} />

      <Route path="admin" element={<AdminLayout />}>
        <Route index element={<AdminHomePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
